import React from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";

import { getSettingState } from "../../../redux/features/settingSlice";

const DynamicThemeBar = () => {
  const { darkMode } = useSelector(getSettingState);
  const theme = useTheme();

  return (
    <Helmet>
      <meta
        name='theme-color'
        content={
          darkMode ? theme.palette.white.main : theme.palette.primary.main
        }
      />
    </Helmet>
  );
};

export default DynamicThemeBar;
